import Grid from '@mui/material/Grid';
import { styled } from '@mui/system';
import type { FunctionComponent, ReactNode } from 'react';

import { SpacingMultiple } from '../../../design/components/constants';
import { SmallText, Text } from '../Typography';

type DataCellProps = {
    readonly id?: string;
    readonly label: string;
    readonly labelSize?: 'smallText' | 'text';
    readonly value: ReactNode;
};

export const DataCell: FunctionComponent<DataCellProps> = ({ id, label, labelSize = 'smallText', value }) => {
    const LabelComponent = labelSize === 'text' ? Text : SmallText;

    return (
        <Grid
            key={label}
            aria-label="data-cell"
            container={true}
            data-cy="data-cell"
            flexDirection="column"
            gap={0.5}
            id={id}
        >
            <LabelComponent>{label}</LabelComponent>
            <Text>{value}</Text>
        </Grid>
    );
};

const StyledGrid = styled('div')(({ theme }) => ({
    display: 'grid',
    gap: theme.spacing(SpacingMultiple.large),
    gridTemplateColumns: 'repeat(auto-fit, minmax(256px, 1fr))',
}));

export type DataGridContainerProps = { readonly data: ReadonlyArray<DataCellProps> };

export const DataGridContainer: FunctionComponent<DataGridContainerProps> = ({ data }) => (
    <StyledGrid>
        {data.map(({ id, label, value }) => (
            <DataCell key={label} id={id} label={label} value={value} />
        ))}
    </StyledGrid>
);
